
import React, { Component } from 'react';
import { PointForm } from 'components/Point/Form';
import {FormContext, FormProvider} from 'core/FormProvider';
import { YellowButton } from 'ui/Button';
import { UserContext } from 'components/User';


export class AddPointDialog extends Component {

  static contextType = UserContext;

  handlePostSave = (item) => {
    const { onClose, onAddOption } = this.props;
    onAddOption(item, false);
    onClose();
  };

  render() {
    return (
      <FormProvider
        url={'catalog/point'}
        postSave={(item) => this.handlePostSave(item)}
        postSaveMessage={'Точка добавлена'}
        item={{
          department: this.context.data.department_active
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <React.Fragment>

              <PointForm />

              <div className={'mt-30'}>
                <YellowButton
                  size={'large'}
                  onClick={(e) => context.handleSubmit(e)}
                  disabled={loading}
                >
                  Создать точку
                </YellowButton>

              </div>
            </React.Fragment>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
